import * as chatAPI from '../api/chat';
import { actionTypes } from './index';
import { addNotification } from './api-notifications';
import { consts } from '../utils/consts';

export const CREATE_CALL_ERROR = 'Please top up your Telmie balance or link your bank card to make this call.';

const createCallAction = (response, calleeBrief) => ({
  type: actionTypes.CREATE_CALL,
  avTime: response.avTime,
  callId: response.id,
  callerId: response.callerId,
  consultant: {
    id: response.consultant.id,
  },
  calleeBrief,
});
const createCallErrorAction = (response = {}) => ({
  type: actionTypes.CREATE_CALL_ERROR,
  info: response.message || CREATE_CALL_ERROR,
  internalError: response.internalError,
});

export const getCallInfo = (response) => (dispatch) => dispatch({
  type: actionTypes.GET_CALL_INFO,
  payload: response,
});

export const caleeIsBusy = () => (dispatch) => dispatch({
  type: actionTypes.CALEE_IS_BUSY,
});

export const speaking = () => (dispatch) => dispatch({
  type: actionTypes.SPEAKING,
});

export const stopCommunication = () => (dispatch) => dispatch({
  type: actionTypes.STOP_COMMUNICATION,
});

export const closeComModal = (type) => (dispatch) => {
  if (type === consts.CHAT) {
    dispatch({
      type: actionTypes.CLOSE_COMMUNICATE_MODAL_CHAT,
    });
  } else {
    dispatch({
      type: actionTypes.CLOSE_COMMUNICATE_MODAL,
    });
  }
};

export const openComModal = (type, person, isOutcoming = false, isIncoming = false) => (dispatch) => {
  if (type === consts.CALL) {
    dispatch({
      type: actionTypes.OPEN_COMMUNICATE_MODAL,
      modalType: type,
      person,
      isOutcoming,
      isIncoming,
    });
  }
  if (type === consts.CHAT) {
    dispatch({
      type: actionTypes.OPEN_COMMUNICATE_MODAL_CHAT,
    });
  }
};

export const processCall = () => (dispatch) => dispatch({
  type: actionTypes.PROCESSING_CALL,
});

export const createCall = (cid, fcid, isPro, _auth, errCallback, callerJID, callProtocolVersion, calleeBrief = undefined) => async (dispatch, getState) => {
  const { loggedInUser: { userAuth } } = getState();

  try {
    const response = await chatAPI.createCall(cid, fcid, isPro, userAuth, callerJID, callProtocolVersion);

    if (response.error) {
      dispatch(createCallErrorAction(response));
      if (errCallback) errCallback();
    } else {
      dispatch(createCallAction(response, calleeBrief));
    }
  } catch (err) {
    dispatch(createCallErrorAction(err));

    if (errCallback) {
      errCallback();
    }
  }
};

export const chooseChatPerson = (person) => (dispatch) => dispatch({
  type: actionTypes.CHOOSE_CHAT_PERSON,
  person,
});

export const changeUnreadNum = (from) => (dispatch) => dispatch({
  type: actionTypes.CHANGE_UNREAD_MSG,
  from,
});

export const clearChats = () => (dispatch) => dispatch({
  type: actionTypes.CLEAR_CHATS,
});

export const pickUp = () => (dispatch) => dispatch({
  type: actionTypes.PICK_UP_CALL,
});

export const changeChat = (data) => (dispatch) => dispatch({
  type: actionTypes.CHANGE_CHAT,
  payload: data,
});

export const changeConnectionStatus = (data) => (dispatch) => dispatch({
  type: actionTypes.CHANGE_CONNECTION_STATUS,
  payload: data,
});

export const changeVideoStatus = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.CHANGE_VIDEO_STATUS,
    payload: data,
  });
};

export const setTimeOffset = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_TIME_OFFSET,
    payload: data,
  });
};

export const sendNotificationFromSupport = () => async (dispatch, getState) => {
  const { loggedInUser: { userAuth } } = getState();
  chatAPI.sendNotificationFromSupport(userAuth);
};

export const reviewCall = (id, rating) => async (dispatch, getState) => {
  const { loggedInUser: { userAuth } } = getState();
  try {
    const response = await chatAPI.reviewCall(id, rating, userAuth);
    dispatch({
      type: actionTypes.GLOBAL_MESSAGE,
      payload: response.message,
    });
  } catch (err) {
    dispatch(addNotification(err));
  }
};

export const changeReconnectionStatus = (isReconnect) => ({
  type: actionTypes.CHANGE_RECONNECTION_STATUS,
  payload: isReconnect,
});

export const clearCallBriefs = () => (dispatch) => {
  dispatch({
    type: actionTypes.CLEAR_CALL_BRIEFS,
  });
};



// WEBPACK FOOTER //
// ./actions/chat.js